"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@material-ui/core/styles");
var __1 = require("..");
var classnames_1 = __importDefault(require("classnames"));
var useStyles = styles_1.makeStyles({
    '@keyframes background': {
        '0%': { 'background-position': '100% 100%' },
        '50%': { 'background-position': '30% 50%' },
        '100%': { 'background-position': '100% 100%' },
    },
    background: {
        backgroundImage: 'url("https://pimage.sport-thieme.de/?file=neubau&format=jpg&scale=1700")',
        position: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
    },
    animation: {
        animation: '$background 30s ease-in-out infinite',
    },
});
function Background(_a) {
    var _b;
    var _c = _a.disableBackdrop, disableBackdrop = _c === void 0 ? false : _c, _d = _a.blur, blur = _d === void 0 ? false : _d, _e = _a.animate, animate = _e === void 0 ? false : _e;
    var classes = useStyles();
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", { className: classnames_1.default(classes.background, (_b = {}, _b[classes.animation] = animate, _b)) }, void 0),
            jsx_runtime_1.jsx(__1.Backdrop, { open: disableBackdrop === false, blur: blur }, void 0)] }, void 0));
}
exports.default = Background;
//# sourceMappingURL=Background.js.map